import { container } from "tsyringe";

// interface
import type { IDateAdapter } from "@/shared/libs/date/interface";
import type { ConfirmAxiosError } from "@/shared/libs/http/axios/interface";
import type { HttpAdapter, HttpAdapterConfig } from "@/shared/libs/http/interface";
import type { AccessStorage } from "@/shared/libs/storage/AccessStorageImpl";
import type { WindowAdapterStructure } from "@/shared/libs/window/interface";

// builder
import { HttpAdapterBuilder } from "@/shared/libs/http/HttpAdapterBuilder";

// impl
import type { CreateOrderKeyImpl } from "@/shared/libs/create-order-key/interface";
import DateAdapter from "@/shared/libs/date/DateAdapter";
import DateFns from "@/shared/libs/date/date-fns/DateFns";
import { AxiosInterceptors } from "@/shared/libs/http/axios/AxiosFetcher";
import { AccessTokenRefresher } from "@/shared/libs/http/axios/AxiosTokenRefresher";
import CreateOrderKeyAdapter from "@/shared/libs/create-order-key/CreateOrderKeyAdapter";
import FractionalIndexing from "@/shared/libs/create-order-key/frational-indexing/FractionalIndexing";
import ConfirmLibsError from "@/shared/libs/http/axios/ConfirmAxiosError";
import { AccessStorageImpl } from "@/shared/libs/storage/AccessStorageImpl";
import WindowAdapter from "@/shared/libs/window/WindowAdapter";

const libsRegisterInit = () => {
    container.register<CreateOrderKeyImpl>("CreateOrderKey", {
        useValue: new CreateOrderKeyAdapter(new FractionalIndexing()),
    });

    container.register<IDateAdapter>("DateAdapter", {
        useValue: new DateAdapter(new DateFns()),
    });
    container.register<ConfirmAxiosError>("ConfirmAxiosError", {
        useValue: new ConfirmLibsError(),
    });
    /**
     * @description
     * HttpAdapter가 의존하는 인스턴스가 많아 factory 형식으로 builder 로 생성
     */
    container.register<HttpAdapter>("HttpAdapter", {
        useFactory: (container) => {
            const config: HttpAdapterConfig = {
                storage: container.resolve(AccessStorageImpl),
                refresher: container.resolve(AccessTokenRefresher),
                interceptors: container.resolve(AxiosInterceptors),
            };
            return HttpAdapterBuilder.build(config);
        },
    });

    container.register<AccessStorage>("AccessStorage", {
        useValue: new AccessStorageImpl(),
    });

    container.register<WindowAdapterStructure>("WindowAdapter", {
        useValue: new WindowAdapter(),
    });
};

export default libsRegisterInit;
